export default "__VITE_ASSET__Co5IfNQ5__"